
let modal = () => {
  document.addEventListener("DOMContentLoaded", () => {
      // Functions to open and close a modal
      function openModal($el,$vid_src) {
          $el.classList.add("is-active");

          if ($el.classList.contains("js-modal-video-url")) {
            $el.querySelector("iframe").setAttribute("src", $vid_src);
          }
          if ($el.classList.contains("js-modal-video-embed")) {
            $el.querySelector(".modal-video-container").innerHTML = $vid_src;

            // Load Vimeo player
            if ($vid_src.includes('vimeo')) {
              var script_tag = document.createElement('script');

              script_tag.src = "https://player.vimeo.com/api/player.js";
              // This gets removed when modal is closed.
              $el.querySelector(".modal-video-container").append(script_tag);
            } 
            // End vimeo 
            
          }
          if ($el.classList.contains("js-modal-video-mp4")) {            
            let videoPlayer = document.querySelector('.js-modal-video-mp4 video');
            videoPlayer.src = $vid_src;
          }
      }

      function closeModal($el) {
          $el.classList.remove("is-active");

          if ($el.classList.contains("js-modal-video-url")) {
              $el.querySelector("iframe").removeAttribute("src");
          }
          if ($el.classList.contains("js-modal-video-embed")) {
              $el.querySelector(".modal-video-container").innerHTML = '';
          }
          if ($el.classList.contains("js-modal-video-mp4")) {
            let videoPlayer = document.querySelector('.js-modal-video-mp4 video');
            videoPlayer.src = '';
          }
      }

      function closeAllModals() {
          (document.querySelectorAll(".modal") || []).forEach(($modal) => {
              closeModal($modal);
          });
      }

      // Add a click event on buttons to open a specific modal
      (document.querySelectorAll(".js-modal-trigger:not([data-isresource])") || []).forEach(
        ($trigger) => {
          const modal = $trigger.dataset.target;
          const src = $trigger.dataset.src;
          const $target = document.getElementById(modal);

          $trigger.addEventListener("click", (e) => {
            e.preventDefault();
            openModal($target, src);
          });
        }
      );

        // CLICK EVENT for modal trigger
        const glide__slides = document.querySelector('.glide__slides');

        glide__slides.addEventListener("click", (e) => {
    
          if( e.target.nodeName === "A" && e.target.classList.contains('js-modal-trigger') ) {
            e.preventDefault();
            let $trigger = e.target;
            let modal = $trigger.dataset.modal;
            let src = $trigger.dataset.src;
            let $target = document.getElementById(modal);
            openModal($target, src);    
          }
                          
        });
  
        // END CLICK EVENT for modal trigger

      // Add a click event on various child elements to close the parent modal
      (
          document.querySelectorAll(
              ".modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button"
          ) || []
      ).forEach(($close) => {
          const $target = $close.closest(".modal");

          $close.addEventListener("click", () => {
              closeModal($target);
          });
      });

      // Add a keyboard event to close all modals
      document.addEventListener("keydown", (event) => {
          const e = event || window.event;

          if (e.keyCode === 27) {
              // Escape key
              closeAllModals();
          }
      });
  
    });

  
  };
    
export { modal };